<template>
  <div class="container videos">
    <div class="columns is-multiline">

      <series-videoitem v-for="video in videos" :key="video.id"
      :item="video" :watched="watched" :current="currentVideo"
      v-on:change-video="changeVideo"></series-videoitem>

    </div>
  </div>

</template>

<script>
import SeriesVideoitem from "@/components/series/SeriesVideoitem.vue";

export default {
  name: `SeriesVideolist`,
  components: {
    SeriesVideoitem
  },
  props: {
    videos: Array,
    sid: String,
    currentVideo: String
  },
  computed: {
    watched() {
      if (Array.isArray(this.$store.state.user.seriesHistory)) {
        const arr = this.$store.state.user.seriesHistory.filter((series) => {
          if (`${series.id}` === `${this.sid}`) {
            return true;
          }
          return false;
        });
        if (arr.length > 0) {
          return arr[0].watched.split(`,`);
        }
        return [];
      }
      return [];
    }
  },

  methods: {
    changeVideo(payload) {
      this.$emit(`change-video`, payload);
    }
  }
};
</script>

<style lang="scss">
.videos {
  max-width: 1344px;
  padding-top: 30px;
  margin-top: 10px;
}
</style>
